import _extends from "@babel/runtime-corejs3/helpers/extends";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import cx from 'classnames';
import React from 'react';
import { internals } from '../internals';
import { Colgroup } from './colgroup';
import SpanManager from './helpers/SpanManager';
import { Classes } from './styles';
export function HtmlTable(_ref) {
  var tbodyHtmlTag = _ref.tbodyHtmlTag,
      getRowProps = _ref.getRowProps,
      primaryKey = _ref.primaryKey,
      data = _ref.data,
      verInfo = _ref.verticalRenderInfo,
      hozInfo = _ref.horizontalRenderInfo;

  var flat = _flatInstanceProperty(hozInfo),
      hoz = hozInfo.horizontalRenderRange;

  var spanManager = new SpanManager();
  var fullFlatCount = flat.full.length;
  var leftFlatCount = flat.left.length;
  var rightFlatCount = flat.right.length;
  return /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement(Colgroup, {
    descriptors: hozInfo.visible
  }), /*#__PURE__*/React.createElement(tbodyHtmlTag, null, _mapInstanceProperty(data).call(data, renderRow)));

  function renderRow(record, i) {
    var _context;

    var rowIndex = verInfo.offset + i;
    spanManager.stripUpwards(rowIndex);
    var rowProps = getRowProps(record, rowIndex);
    var rowClass = cx(Classes.tableRow, {
      first: rowIndex === verInfo.first,
      last: rowIndex === verInfo.last,
      even: rowIndex % 2 === 0,
      odd: rowIndex % 2 === 1
    }, rowProps === null || rowProps === void 0 ? void 0 : rowProps.className);
    return /*#__PURE__*/React.createElement("tr", _extends({}, rowProps, {
      className: rowClass,
      key: internals.safeGetRowKey(primaryKey, record, rowIndex),
      "data-rowindex": rowIndex,
      "data-role": 'table-row'
    }), _mapInstanceProperty(_context = hozInfo.visible).call(_context, function (descriptor) {
      if (descriptor.type === 'blank') {
        return /*#__PURE__*/React.createElement("td", {
          key: descriptor.blankSide
        });
      }

      return renderBodyCell(record, rowIndex, descriptor.col, descriptor.colIndex);
    }));
  }

  function renderBodyCell(record, rowIndex, column, colIndex) {
    var _a, _b, _c;

    if (spanManager.testSkip(rowIndex, colIndex)) {
      return null;
    }

    var value = internals.safeGetValue(column, record, rowIndex);
    var cellProps = (_b = (_a = column.getCellProps) === null || _a === void 0 ? void 0 : _a.call(column, value, record, rowIndex)) !== null && _b !== void 0 ? _b : {};
    var cellContent = value;

    if (column.render) {
      cellContent = column.render(value, record, rowIndex);
    }

    var colSpan = 1;
    var rowSpan = 1;

    if (column.getSpanRect) {
      var spanRect = column.getSpanRect(value, record, rowIndex);
      colSpan = spanRect == null ? 1 : spanRect.right - colIndex;
      rowSpan = spanRect == null ? 1 : spanRect.bottom - rowIndex;
    } else {
      if (cellProps.colSpan != null) {
        colSpan = cellProps.colSpan;
      }

      if (cellProps.rowSpan != null) {
        rowSpan = cellProps.rowSpan;
      }
    } // rowSpan/colSpan 不能过大，避免 rowSpan/colSpan 影响因虚拟滚动而未渲染的单元格


    rowSpan = Math.min(rowSpan, verInfo.limit - rowIndex);
    colSpan = Math.min(colSpan, leftFlatCount + hoz.rightIndex - colIndex);
    var hasSpan = colSpan > 1 || rowSpan > 1;

    if (hasSpan) {
      spanManager.add(rowIndex, colIndex, colSpan, rowSpan);
    }

    var positionStyle = {};

    if (colIndex < leftFlatCount) {
      positionStyle.position = 'sticky';
      positionStyle.left = hozInfo.stickyLeftMap.get(colIndex);
    } else if (colIndex >= fullFlatCount - rightFlatCount) {
      positionStyle.position = 'sticky';
      positionStyle.right = hozInfo.stickyRightMap.get(colIndex);
    }

    return /*#__PURE__*/React.createElement('td', _extends(_extends(_extends(_extends({
      key: colIndex
    }, cellProps), {
      className: cx(Classes.tableCell, cellProps.className, {
        // class
        first: colIndex === 0,
        last: colIndex + colSpan === fullFlatCount,
        'lock-left': colIndex < leftFlatCount,
        'lock-right': colIndex >= fullFlatCount - rightFlatCount,
        'row-span': rowSpan > 1
      })
    }), hasSpan ? {
      colSpan: colSpan,
      rowSpan: rowSpan
    } : null), {
      style: _extends(_extends({
        textAlign: column.align,
        verticalAlign: (_c = column.verticalAlign) !== null && _c !== void 0 ? _c : 'middle'
      }, cellProps.style), positionStyle),
      'data-role': 'table-cell',
      'data-rowindex': rowIndex,
      'data-code': column.code
    }), cellContent);
  }
}